export function getActiveQuestion({ questions, activeQuestion }) {
  return { ...questions[activeQuestion] };
}

export function getAnswer(answer) {
  return state => state.quote.answers[answer];
}
